module.exports = __webpack_public_path__ + "static/media/account.1185c356.svg";